import React from "react";

export default function PaymentProcessing() {
    return <div className="prepaid-refill">Gjennomfører kjøp....</div>;
}
